// EntityList's loading view; the host's lazy EntityList shows the same one until its chunk lands.
// Kept out of EntityList.tsx so the first chunk can import it without EntityList.
import type { ReactElement } from 'react';

export function ListLoadingSpinner(): ReactElement {
  return (
    <div className="flex flex-1 items-center justify-center" data-testid="list-loading-spinner">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent dark:border-primary-400" />
    </div>
  );
}
